module.exports = __webpack_public_path__ + "static/media/coming-soon.9faf8933.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coming-soon.png
// module id = 1698
// module chunks = 0